import {Box, css, styled} from '@mui/material';
import {CTAButtonFixed} from 'presentation/components/CTAButtonFixed';

type StyledFooterContainerProps = {
	$mb?: number;
	$isTablet?: boolean;
};

export const StyledFooterContainer = styled(Box)<StyledFooterContainerProps>`
	margin: ${props => (props.$mb ? `auto 0px ${props.$mb}px` : 'auto 0px 32px')};
	padding-top: 40px;

	${({$isTablet}) =>
		$isTablet &&
		css`
			margin: auto 0px 0px;
			& footer {
				margin-inline: 24px;
			}
		`}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;

export const CustomCTAButtonFixedAction = styled(CTAButtonFixed.Action)`
	padding: 8px 22px;
`;
